/**
 * TourLauncher - the "Take the tour" list for Help (Teams app) or a panel's
 * help menu: every tour for this person's roles, whether they have done it,
 * and a button to run it again.
 */
import { useGuidedTour } from './GuidedTourProvider';

export function TourLauncher({ emptyText }: { emptyText?: string }): JSX.Element {
  const { tours, progress, start } = useGuidedTour();
  if (tours.length === 0) {
    return <p className="tour-launcher__empty">{emptyText ?? 'There is no guided tour for your role yet.'}</p>;
  }
  return (
    <ul className="tour-launcher">
      {tours.map((t) => {
        const p = progress.find((x) => x.tourId === t.id && x.version >= t.version);
        const state = p?.status === 'completed' ? 'Done' : p?.status === 'dismissed' ? 'Started, not finished' : 'Not taken yet';
        return (
          <li key={t.id} className="tour-launcher__item">
            <div>
              <div className="tour-launcher__title">{t.title}</div>
              <div className="tour-launcher__summary">{t.summary} · {t.steps.length} steps</div>
              {t.launchHint && <div className="tour-launcher__summary">{t.launchHint}</div>}
              <div className={`tour-launcher__state ${p?.status === 'completed' ? 'is-done' : ''}`.trim()}>{state}</div>
            </div>
            <button type="button" className="tour-btn tour-btn--primary" onClick={() => start(t.id)}>
              {p ? 'Take it again' : 'Take the tour'}
            </button>
          </li>
        );
      })}
    </ul>
  );
}

export default TourLauncher;
